module.exports = __webpack_public_path__ + "img/desktop-afraid.b45f3df0.png";